import React, { Component } from 'react';
import Button from '../Buttons'

export default class PreviousButton extends Component {

  render(){

  	const { onClickPrev } = this.props
  	
    return (
      <Button type="submit" classes="pag-btn" clickButton={onClickPrev}>
        <i className="fa fa-caret-left"></i>
      </Button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pagination/previous.js